var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 4C7.622 4 5.694 5.928 5.694 8.306v4.027H5v.834h10v-.834h-.694V8.306C14.306 5.928 12.378 4 10 4zm3.472 8.333V8.306c0-1.918-1.554-3.473-3.472-3.473S6.528 6.388 6.528 8.306v4.027h6.944zM8.706 14.23c.14.278.336.502.563.653.227.152.48.228.731.228.252 0 .504-.076.73-.228.228-.151.425-.375.564-.653l.745.373c-.2.398-.489.736-.846.974-.358.239-.77.367-1.193.367-.423 0-.835-.129-1.193-.367-.357-.238-.647-.576-.846-.974l.745-.373z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.8,
    d: "M16 7.728c0-1.413-.835-3.084-2-3.728M4 7.728C4 6.315 4.835 4.644 6 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActive);
export default __webpack_public_path__ + "static/media/icon-active.462c773f.svg";
export { ForwardRef as ReactComponent };